export default "__VITE_ASSET__C8R3oFMc__"